import Marquee from "react-fast-marquee";

const WORDS = ["Empowerment", "Prevenzione", "Sicurezza", "Community", "Coraggio"];

export const Ribbon = () => {
  return (
    <section
      data-testid="ribbon-section"
      className="py-16 sm:py-24 bg-brand-bg overflow-hidden edge-fade-x"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-brand-text text-6xl sm:text-8xl md:text-[9rem] leading-none px-8">
              {w}
            </span>
            <span className="h-3 w-3 rounded-full bg-brand-primary" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default Ribbon;
